import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_EPO_WATCH_ACTION_TYPE = createNamedActions('commandCenterEpoWatch', {
  SET_EPO_WATCH: 'SET_EPO_WATCH',
});

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterEpoWatchAction = catchAsyncActionError(() => async dispatch => {
  try {
    const data = await fetchSafe(() =>
      commandCenterLoansApi.getEpoWatch({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    dispatch({
      type: COMMAND_CENTER_EPO_WATCH_ACTION_TYPE.SET_EPO_WATCH,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403/404
    // degrades to null — otherwise the zone skeleton never clears (DEV-4176).
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.EPO_WATCH));
  }
});
